import {updateUser} from "API/usersApi";
import LoadingSpinner from "components/Loading/LoadingSpinner";
import {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {toast} from "react-toastify";
import messageFromError from "utils/errorUtils";
import PasswordMeter from "../../PasswordMeter";
import {useTranslation} from "react-i18next";

const ChangePasswordModal = ({show, onHide, onUpdate, userId}) => {

    const [password, setPassword] = useState(null)
    const [showSpinner, setShowSpinner] = useState(false)

    const {t} = useTranslation()

    async function updatePassword() {
        try {
            setShowSpinner(true)
            await updateUser(userId, { password: password })
            toast.success("Password Updated")
            onUpdate()
            onHide()
        }
        catch (error) {
            toast.error(messageFromError(error))
        }
        finally {
            setShowSpinner(false)
        }
    }

    return (
        <Modal centered show={show} onHide={() => {!showSpinner && onHide()}}>
            <Modal.Header className='modal-header' closeButton={!showSpinner}>
                <Modal.Title>{t('pages.users.changePasswordDialog.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PasswordMeter
                    text={t('pages.users.changePasswordDialog.newPassword')}
                    className='mt-3'
                    onSufficientPassword={(p) => {
                        setPassword(p)
                    }}
                    onUnSufficientPassword={() => {
                        setPassword(null)
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                {showSpinner ? <LoadingSpinner variant="success"/> : 
                    <Button disabled={password === null} onClick={updatePassword} variant="success">{t('global.operations.update')}</Button>
                }
            
            </Modal.Footer>
        </Modal>
    );
};

export default ChangePasswordModal;